import * as am4core from "@amcharts/amcharts4/core";

export const am4Settings = {
    // The Actual Date Formatter Info
    dateFormatter: null,

    // Actual setting to use UTC or company timezone
    useUTC: false,

    // The Actual setting on whether we use short gaps.
    useShortGaps: false,

    // Handler to update the UI Componenet (Use Sparingly)
    updateVueHook: null,

    // Group Count
    GROUP_COUNT: 750,

    // Axis location descriptors
    AXIS_LEFT: 0,
    AXIS_RIGHT: 1,

    // Loading Intervals
    RELOAD_FREQUENCY: 1000,
    RELOAD_FREQUENCY_FINISHED: 10000000,
    LOAD_DATA_DELAY: 50,

    // Bullet Density
    MIN_BULLET_DISTANCE: 10,


    // Gap Length in Minutes
    SHORT_GAP_LENGTH: 30,
    LONG_GAP_LENGTH: 12 * 60,

    Y_AXIS_SPACE_PERCENT: 0.05,

    FATHOM_GOALS: {
        showSeries: '23DDHL1I',
        showPairedPoint: 'AFOFOVBO',
        addNewSeriesToPlot: 'RUSGFGJS',
    },

    BACK_FILL_COLOR: am4core.color('#cccf1c'),
    COLOR_ALARM: am4core.color('#8f000f'),
    COLOR_CAUTION: am4core.color('#bfcf29'),
}